import { ResponsiveSelect } from "../../../../../components/MobileForm";
import { InlineToggle } from "../../../../../components/InlineToggle";
import {
  SORT_OPTIONS,
  sortStateToValue,
  valueToSortState,
} from "../InvestmentsHoldings";
import { CountLabel, LeftGroup, SelectField, Wrapper } from "./styles";
import { InvestmentsFiltersProps } from "./types";

export const InvestmentsFilters: React.FC<InvestmentsFiltersProps> = ({
  variant,
  isCompact,
  periodValue,
  periodOptions,
  onPeriodChange,
  activeOnly,
  onActiveOnlyChange,
  count,
  showSort,
  sort,
  onSortChange,
}) => {
  const showCount = variant === "inline";
  const renderSort = showSort && variant === "standalone";
  const countLabel = `${count} ${count === 1 ? "investment" : "investments"}`;

  const sortValue = sortStateToValue(sort);

  return (
    <Wrapper $variant={variant}>
      <LeftGroup $variant={variant}>
        <SelectField>
          <ResponsiveSelect
            isCompact={isCompact}
            options={periodOptions}
            value={periodValue}
            onChange={(option) => onPeriodChange(option.value)}
            sheetTitle="Select period"
            testId="investments-period-filter"
          />
        </SelectField>

        <InlineToggle
          checked={activeOnly}
          onChange={onActiveOnlyChange}
          label="Active only"
          accent="primary"
          ariaLabel="Show active investments only"
          testId="investments-active-only-filter"
        />
      </LeftGroup>

      {renderSort && (
        <ResponsiveSelect
          isCompact={isCompact}
          options={SORT_OPTIONS}
          value={sortValue}
          onChange={(option) => onSortChange(valueToSortState(option.value))}
          sheetTitle="Sort by"
          testId="investments-period-sort"
        />
      )}
      {showCount && <CountLabel>{countLabel}</CountLabel>}
    </Wrapper>
  );
};
